import { ComplexFilterItem } from "interfaces/filters";
import { PropertyReport, PropertyYearReport, GroupedPropertyReport, PropertyKPIData } from "interfaces/reports";
import {
	DashboardActionTypes,
	GetDashboardReportAction,
	GetDashboardReportFailAction,
	GetDashboardReportStartAction,
	GetDashboardYearReportAction,
	GetDashboardYearReportFailAction,
	GetDashboardYearReportStartAction,
	SetDashboardFilterAction,
	SetDashboardReportAction,
	SetDashboardReportYearAction,
	SetDashboardYearReportAction,
	GetDashboardKPIReportAction,
	GetDashboardKPIReportStartAction,
	GetDashboardKPIReportFailAction,
	SetDashboardKPIReportAction,
	SetDashboardKPIDataAction,
	SetKPISortByAction,
	SetKPICurrentPageAction,
} from "./types";

export function getDashboardReport(): GetDashboardReportAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_REPORT,
	};
}

export function getDashboardReportStart(): GetDashboardReportStartAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_REPORT_START,
	};
}

export function getDashboardReportFail(): GetDashboardReportFailAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_REPORT_FAIL,
	};
}

export function setDashboardReport(
	payload: PropertyReport
): SetDashboardReportAction {
	return {
		type: DashboardActionTypes.SET_DASHBOARD_REPORT,
		payload,
	};
}

export function setDashboardFilter(
	payload: ComplexFilterItem[]
): SetDashboardFilterAction {
	return {
		type: DashboardActionTypes.SET_DASHBOARD_FILTER,
		payload,
	};
}

export function setDashboardReportYear(
	payload: number
): SetDashboardReportYearAction {
	return {
		type: DashboardActionTypes.SET_YEAR,
		payload,
	};
}

export function setDashboardYearReport(
	payload: PropertyYearReport
): SetDashboardYearReportAction {
	return {
		type: DashboardActionTypes.SET_DASHBOARD_YEAR_REPORT,
		payload,
	};
}

export function getDashboardYearReport(): GetDashboardYearReportAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_YEAR_REPORT,
	};
}

export function getDashboardYearReportStart(): GetDashboardYearReportStartAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_YEAR_REPORT_START,
	};
}

export function getDashboardYearReportFail(): GetDashboardYearReportFailAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_YEAR_REPORT_FAIL,
	};
}

export function getDashboardKPIReport(): GetDashboardKPIReportAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_KPI_REPORT,
	};
}

export function getDashboardKPIReportStart(): GetDashboardKPIReportStartAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_KPI_REPORT_START,
	};
}

export function getDashboardKPIReportFail(): GetDashboardKPIReportFailAction {
	return {
		type: DashboardActionTypes.GET_DASHBOARD_KPI_REPORT_FAIL,
	};
}

export function setDashboardKPIReport(
	payload: GroupedPropertyReport
): SetDashboardKPIReportAction {
	return {
		type: DashboardActionTypes.SET_DASHBOARD_KPI_REPORT,
		payload,
	};
}

export function setDashboardKPIData(
	payload: PropertyKPIData[]
): SetDashboardKPIDataAction {
	return {
		type: DashboardActionTypes.SET_DASHBOARD_KPI_DATA,
		payload,
	};
}

export function setKPISortBy(
	payload: 'highest' | 'lowest'
): SetKPISortByAction {
	return {
		type: DashboardActionTypes.SET_KPI_SORT_BY,
		payload,
	};
}

export function setKPICurrentPage(
	payload: number
): SetKPICurrentPageAction {
	return {
		type: DashboardActionTypes.SET_KPI_CURRENT_PAGE,
		payload,
	};
}

